import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Data, MealItem } from './services/data';
import { Messenger } from './services/messenger';
var SearchComponent = /** @class */ (function () {
    function SearchComponent(data, messenger) {
        this.data = data;
        this.messenger = messenger;
        this.term = new FormControl('');
        this.foods = [];
        this.onFoodClicked = new EventEmitter();
    }
    SearchComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.data.isReady()) {
                    this.subscribe();
                }
                else {
                    this.term.disable();
                    this.messenger.send('Unable to search while database is setting up', true);
                }
                return [2 /*return*/];
            });
        });
    };
    SearchComponent.prototype.subscribe = function () {
        var _this = this;
        this.term.valueChanges.subscribe(function (next) {
            if (_this.debounce) {
                clearTimeout(_this.debounce);
            }
            _this.debounce = setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchDatabase()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            }); }); }, 500);
        });
    };
    SearchComponent.prototype.searchDatabase = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var term, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        term = this.term.value;
                        if (term === '') {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.data.findFood(term)];
                    case 1:
                        _a.foods = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchComponent.prototype.foodClicked = function (id) {
        this.onFoodClicked.emit(id);
    };
    return SearchComponent;
}());
export { SearchComponent };
